import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import SeasonDashboard from './SeasonDashboard';

const SeasonDashboardPortal = () => {
  const location = useLocation();
  const [mountNode, setMountNode] = useState(null);

  useEffect(() => {
    if (location.pathname !== '/') {
      setMountNode(null);
      return undefined;
    }

    let cancelled = false;
    let tries = 0;
    let node = null;

    const findHero = () => {
      if (cancelled) return;
      const sections = Array.from(document.querySelectorAll('section'));
      const hero = sections.find((section) =>
        section.classList.contains('relative') &&
        section.classList.contains('flex') &&
        section.classList.contains('items-center') &&
        section.classList.contains('justify-center')
      );

      if (hero?.parentNode) {
        node = document.createElement('div');
        node.setAttribute('data-season-dashboard-portal', 'true');
        node.className = 'bg-slate-50 py-8 md:py-10';
        const inner = document.createElement('div');
        inner.className = 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8';
        node.appendChild(inner);
        hero.parentNode.insertBefore(node, hero.nextSibling);
        setMountNode(inner);
        return;
      }

      tries += 1;
      if (tries < 20) window.setTimeout(findHero, 100);
    };

    findHero();
    return () => {
      cancelled = true;
      setMountNode(null);
      if (node?.parentNode) node.parentNode.removeChild(node);
    };
  }, [location.pathname]);

  if (!mountNode) return null;
  return createPortal(<SeasonDashboard compact defaultCategory="Senior" defaultSeason="2026-27" />, mountNode);
};

export default SeasonDashboardPortal;
